import { BreadcrumbType, BugsnagStatic, Config, Event, NotifiableError, OnErrorCallback } from '@bugsnag/js';

declare global {
  interface Window {
    /**
     *
     * @deprecated Use ErrorReporter or BugsnagService
     */
    Bugsnag?: BugsnagStatic;
    BugsnagConfig?: Config & { loadingDeferred?: boolean };
  }
}

export namespace BugsnagHelpers {
  /**
   *
   * @deprecated Use ErrorReporter
   */
  export function notifySafely(
    error: NotifiableError,
    onError?: OnErrorCallback,
    postReportCallback?: (err: any, event: Event) => void
  ): void {
    window.Bugsnag?.notify(error, onError, postReportCallback);
  }

  /**
   *
   * @deprecated Use BugsnagService
   */
  export function leaveBreadcrumbSafely(
    message: string,
    metadata?: { [key: string]: any },
    type?: BreadcrumbType
  ): void {
    window.Bugsnag?.leaveBreadcrumb(message, metadata, type);
  }
}
